import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ZapIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center pt-24 pb-16 px-6 overflow-hidden bg-gradient-to-br from-navy-900 via-navy-600 to-navy-700" data-id="element-77">
      {/* Background Glow */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-neon/10 rounded-full blur-[120px] pointer-events-none" data-id="element-78" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-600/10 rounded-full blur-[120px] pointer-events-none" data-id="element-79" />

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-80">
        {/* Left Content */}
        <motion.div variants={staggerContainer} initial="hidden" animate="show" className="flex flex-col items-start text-left" data-id="element-81">
          <motion.div variants={fadeUp} className="flex items-center gap-3 mb-6 flex-wrap" data-id="element-82">
            <div className="flex text-gold" data-id="element-83">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-84" />)}
            </div>
            <span className="text-cyan-neon text-xs md:text-sm font-bold tracking-[0.2em] uppercase" data-id="element-85">
              Producto Premium · Descarga Inmediata
            </span>
          </motion.div>

          <motion.h1 variants={fadeUp} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-86">
            Deja de perder 3 horas al día en tareas que la IA puede resolver en{' '}
            <span className="text-cyan-neon" data-id="element-87">30 segundos.</span>
          </motion.h1>

          <motion.h2 variants={fadeUp} className="text-lg md:text-xl text-slate-300 mb-8 leading-relaxed max-w-2xl" data-id="element-88">
            La guía definitiva con los prompts exactos para automatizar tu
            trabajo, organizar tu vida y recuperar tu libertad hoy mismo.
          </motion.h2>

          <motion.div variants={fadeUp} className="flex flex-wrap items-center gap-4 mb-8" data-id="element-89">
            <span className="text-slate-400 text-lg line-through decoration-red-500/50" data-id="element-90">
              Precio Regular: $47 USD
            </span>
            <span className="text-3xl md:text-4xl font-black text-cyan-neon" data-id="element-91">
              Hoy: Solo $6.39 USD
            </span>
            <span className="bg-red-500/20 text-red-400 border border-red-500/30 px-3 py-1 rounded-full text-sm font-bold" data-id="element-92">
              Ahorra un 60% por tiempo limitado
            </span>
          </motion.div>

          <motion.button variants={fadeUp} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => {
          document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="w-full max-w-[400px] bg-gradient-to-r from-green-cta to-green-cta-light text-black font-black text-lg md:text-xl py-5 px-8 rounded-xl cta-pulse shadow-[0_0_30px_rgba(0,200,83,0.4)] mb-8 transition-all" data-id="element-93">
            ➜ QUIERO MI GUÍA AHORA
          </motion.button>

          <motion.div variants={fadeUp} className="flex flex-wrap items-center gap-6 text-sm font-semibold" data-id="element-94">
            <div className="flex items-center gap-2 text-gold" data-id="element-95">
              <StarIcon className="w-4 h-4 fill-current" data-id="element-96" />
              <span data-id="element-97">Producto Premium: +2,500 copias vendidas</span>
            </div>
            <div className="flex items-center gap-2 text-cyan-neon" data-id="element-98">
              <ZapIcon className="w-4 h-4 fill-current" data-id="element-99" />
              <span data-id="element-100">Entrega Directa: Acceso instantáneo a tu correo</span>
            </div>
          </motion.div>
        </motion.div>

        {/* Right Content - 3D Mockup */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex justify-center items-center py-12" data-id="element-101">
          <motion.div animate={{
          y: [0, -12, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative" data-id="element-102">
            {/* Cyan glow behind the book */}
            <div className="absolute inset-0 bg-cyan-neon/15 blur-[60px] rounded-full scale-90 pointer-events-none" data-id="element-103"></div>
            <img src="https://cdn.magicpatterns.com/uploads/q2PCTXKn3RCpQdFCu3QDhr/heylloyd-image-1773796068402sin_fondo_2.png" alt="eBook IA al Rescate - Domina ChatGPT y Simplifica tu Vida en Minutos" className="relative z-10 w-full max-w-[380px] drop-shadow-[0_20px_60px_rgba(0,242,255,0.25)]" data-id="element-104" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}